import React, { Component } from "react";
import { clearErrors } from "../../../actions/errorsActions";
import SideMenuOffices from "../../../components/layout/SideMenuOffices";
import SideMenu from "../../../components/layout/SideMenu";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Navigate from "../../../components/Navigate/Navigate";
import Spinner from "../../../components/common/Spinner";
import DifficultyCard from "../../../components/Cards/DifficultyCard";
// import failToast from "../../../components/toast/failToast";
import { roles } from "../../../enums/roles";
import { pageType } from "../../../enums/pageType";
import { getDifficulties } from "../../../actions/difficultyActions";
import CheckPermissions from "../../../validation/CheckPermissions";
import { Link } from "react-router-dom";

import { withRouter } from "react-router-dom";

class Difficulties extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {},
      mounted: false,
      difficulties: this.props.difficulties.difficulties,
      rolesAllowedToOpen: [roles.SUPERADMINISTRATOR, roles.ADMINISTRATOR],
      auth: {},
      difficultiesMapped: [],
      errors: {},
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let update = {};
    if (nextProps.auth) {
      var tokenUserOffices = nextProps.auth.user.offices;
      update.singleOffice = tokenUserOffices && tokenUserOffices.length === 1 ? true : false;
      if (nextProps.auth !== prevState.auth) {
        var dataToCheck = {
          isAuthenticated: nextProps.auth.isAuthenticated,
          user_type: nextProps.auth.user.type,
          root_link: `/admin/offices`,
          user_offices: nextProps.auth.user.offices,
          office_id: nextProps.match.params.officeId,
          previous_link: `/admin/${nextProps.match.params.officeId}/dashboard`,
          roles_allowed_to_write: prevState.rolesAllowedToOpen,
          page_type: pageType.WRITE,
          history: nextProps.history,
        };

        CheckPermissions(dataToCheck);

        if (nextProps.errors) {
          update.errors = nextProps.errors;
        }
        update.auth = nextProps.auth;
      }
      // if (nextProps.difficulties && nextProps.difficulties.difficulties) {
      if (nextProps.difficulties.difficulties !== prevState.difficulties) {
        update.difficulties = nextProps.difficulties.difficulties;

        var difficulties = nextProps.difficulties.difficulties;

        var mappedDifficulties = [];
        difficulties &&
          difficulties.map((difficulty) => {
            return mappedDifficulties.push({
              id: difficulty.id,
              difficulty: difficulty.difficulty,
              link: `/admin/${nextProps.match.params.officeId}/edit-difficulty/${difficulty.id}`,
            });
          });

        if (mappedDifficulties.length > 0) {
          update.difficultiesMapped = mappedDifficulties;
        } else {
          update.difficultiesMapped = null;
        }
      }
      // }
    }
    return Object.keys(update).length ? update : null;
  }
  componentDidMount() {
    var dataToCheck = {
      isAuthenticated: this.props.auth.isAuthenticated,
      user_type: this.props.auth.user.type,
      root_link: `/admin/offices`,
      user_offices: this.props.auth.user.offices,
      office_id: this.props.match.params.officeId,
      previous_link: `/admin/${this.props.match.params.officeId}/dashboard`,
      roles_allowed_to_write: this.state.rolesAllowedToOpen,
      page_type: pageType.WRITE,
      history: this.props.history,
    };

    if (CheckPermissions(dataToCheck)) {
      this.props.getDifficulties(this.props.match.params.officeId, (err) => {});
    }

    // this.props.getDifficulties(this.props.match.params.officeId, (err) => {
    //   if (err.status !== 200) {
    //     failToast(err.data.errors);
    //   }
    // });
  }
  render() {
    const {
      // difficulties,
      loading,
    } = this.props.difficulties;
    var content = "";
    if (this.state.difficultiesMapped === [] || loading) {
      content = <Spinner />;
    } else {
      content = <DifficultyCard difficulties={this.state.difficultiesMapped} />;
    }

    return (
      <div className="grid-menu-container">
        <div className="menu-grid">
          <div className="menu">
            <SideMenuOffices props={this.props} />
            <hr />
            <SideMenu props={this.props} />
          </div>
        </div>
        <div className="main-grid">
          <div className="main">
            <Navigate
              title={"Difficulties"}
              link={`/admin/${this.props.match.params.officeId}/settings`}
              buttons={[
                <Link to={`/admin/${this.props.match.params.officeId}/new-difficulty`} className="btn btn-primary">
                  Add Difficulty
                </Link>,
              ]}
            />
            {content}
          </div>
        </div>
      </div>
    );
  }
}

Difficulties.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors,
  difficulties: state.difficulties,
});

export default connect(mapStateToProps, { getDifficulties, clearErrors })(withRouter(Difficulties));
